import React, { useEffect, useState } from "react";
import { Loader2, ThumbsUp, ThumbsDown, MessageSquare, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, StatCard } from "@/components/admin/AdminUI";

export default function AdminEmieQuality() {
  const [q, setQ] = useState(null);

  useEffect(() => {
    api.get("/admin/emie-quality").then((r) => setQ(r.data)).catch(() => setQ(false));
  }, []);

  if (q === null)
    return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>;
  if (q === false) return <p className="text-sm text-destructive">Failed to load EMIE quality.</p>;

  return (
    <div data-testid="admin-emie-quality">
      <PageHeader title="EMIE Quality" subtitle="Satisfaction from user thumbs up / down ratings" />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard
          testid="emie-satisfaction"
          label="Satisfaction"
          value={q.satisfaction != null ? `${q.satisfaction}%` : "—"}
          accent
          hint={`${q.rated} rated of ${q.total_responses}`}
        />
        <StatCard testid="emie-up" label="Thumbs up" value={q.thumbs_up} />
        <StatCard testid="emie-down" label="Thumbs down" value={q.thumbs_down} />
        <StatCard testid="emie-convos" label="Conversations" value={q.total_conversations} hint={`${q.user_messages} questions asked`} />
      </div>

      <div className="mt-8">
        <div className="mb-4 flex items-center gap-2">
          <ThumbsDown className="h-4 w-4 text-destructive" />
          <h2 className="font-display text-lg font-bold">Flagged responses</h2>
          <span className="text-sm text-muted-foreground">(down-rated)</span>
        </div>

        {q.flagged.length === 0 ? (
          <div className="flex min-h-[200px] flex-col items-center justify-center rounded-2xl border-2 border-dashed border-border/60 bg-card/40 text-center" data-testid="emie-flagged-empty">
            <Sparkles className="h-8 w-8 text-primary" />
            <p className="mt-3 font-display font-bold">No flagged responses</p>
            <p className="mt-1 text-sm text-muted-foreground">Users haven't down-rated any EMIE replies yet.</p>
          </div>
        ) : (
          <div className="space-y-3" data-testid="emie-flagged-list">
            {q.flagged.map((f, i) => (
              <div key={i} className="rounded-xl border border-destructive/30 bg-card p-4" data-testid={`emie-flagged-${i}`}>
                <div className="flex items-start gap-2">
                  <MessageSquare className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
                  <p className="text-sm font-medium">{f.question}</p>
                </div>
                <div className="mt-2 flex items-start gap-2 rounded-lg bg-muted/50 p-3">
                  <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                  <p className="text-sm text-muted-foreground">{f.answer}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
